import PageNumber from 'components/PageNumber/PageNumber';
import BaseTableJs from 'components/Tables/BaseTable';
import { useMemo } from 'react';
import { AuditLogFilters } from '../utils/searchBuilder';
// Cast to `any` to suppress type errors since the component isn't typed yet
const BaseTable = BaseTableJs as any;

interface AuditLogRow {
  id: number;
  created_at: string;
  user_id: number;
  user_name: string;
  workplace_id: number;
  domain: string;
  category: string;
  description: string;
  entity_type: string | null;
  entity_id: number | null;
  metadata: Record<string, unknown>;
}

interface AuditLogResponse {
  page: number;
  pageSize: number;
  totalPages: number;
  results: AuditLogRow[];
}

interface Props {
  data: AuditLogResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  filters: AuditLogFilters;
  onFiltersChange: (filters: AuditLogFilters) => void;
}

const COLUMNS = [
      {
    header: 'Category',
    accessorKey: 'category',
    Cell: ({ cell }: { cell: { getValue: () => string } }) => {
      const value = cell.getValue();
      return <div className="text-white fs-6">{value}</div>;
    },
  },
  {
    header: 'User',
    accessorKey: 'user_name',
    Cell: ({ cell }: { cell: { getValue: () => string } }) => {
      const value = cell.getValue();
      return <div className="text-white fs-6">{value}</div>;
    },
  },
{
    header: 'Domain',
    accessorKey: 'domain',
    Cell: ({ cell }: { cell: { getValue: () => string } }) => {
      const value = cell.getValue();
      return <div className="text-white fs-6">{value}</div>;
    },
  },
  {
    header: 'Date',
    accessorKey: 'created_at',
    Cell: ({ cell }: { cell: { getValue: () => string } }) => {
      const value = cell.getValue();
      return <div className="text-white fs-6">{new Date(value).toLocaleString()}</div>;
    },
  },
];

export default function AuditLogTable({ data, isLoading, isError, filters, onFiltersChange }: Props) {
  const rows = useMemo(() => data?.results ?? [], [data]);

  if (isError) {
    return <p className="text-danger small">Failed to load audit logs.</p>;
  }

  return (
    <div className="d-flex flex-column gap-2">
      <BaseTable
        rows={rows}
        columns={COLUMNS}
        expandable={true}
        dropdownMenu={(row: AuditLogRow) => (
          <div className="px-3 py-2">
            <p className="text-white mb-0 fs-6">{row.description}</p>
          </div>
        )}
        enableRowVirtualization={false}
        customEmptyMessage={isLoading ? 'Loading…' : 'No audit logs found.'}
      />

      {/* Pagination — PageNumber is 0-based; API is 1-based, so convert at the boundary */}
      {data && (
        <PageNumber
          pages={data.totalPages}
          value={data.page - 1}
          onChange={(zeroBasedPage) => onFiltersChange({ ...filters, page: zeroBasedPage + 1 })}
        />
      )}
    </div>
  );
}
